<template>
    <v-container fluid fill-height>
        <v-layout text-center wrap align-center justify-center>
            <v-flex xs12 sm12>
                <h1 class="display-1 my-5">
                    <span class="font-weight-bold">Pacato</span>
                    > Nova Música Gospel
                </h1>

                <v-layout class="my-5" grid-list-xl wrap align-center justify-center>
                    <v-flex xs12 sm8 md5 xl4>
                        <v-alert
                            v-if="show_message"
                            dense
                            outlined
                            type="error"
                        >Usuário ou senha inválido.</v-alert>

                        <v-card class="elevation-0" style="background-color:#fafafa">
                            <v-alert
                                dense
                                outlined
                                :type="message.type"
                                v-if="message.message!=null"
                            >{{message.message}}</v-alert>

                            <v-card-text>
                                <v-form @keyup.native.enter="login()">
                                    <v-text-field
                                        label="Email"
                                        name="email"
                                        prepend-icon="person"
                                        type="text"
                                        v-model="credential.email"
                                        autocomplete="username"
                                        v-validate="'required|email'"
                                        data-vv-name="email"
                                        :error-messages="errors.collect('email')"
                                    ></v-text-field>

                                    <v-text-field
                                        id="password"
                                        label="Senha"
                                        prepend-icon="lock"
                                        type="password"
                                        v-model="credential.password"
                                        autocomplete="current_password"
                                        v-validate="'required|min:8'"
                                        data-vv-name="password"
                                        :error-messages="errors.collect('password')"
                                    ></v-text-field>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>                                                             

                                <v-spacer></v-spacer>
                                <!--v-btn
                                    :to="{name:'resetpassword'}"
                                    class="elevation-0"
                                    text
                                >Recuperar senha</v-btn-->

                                <!--v-btn class="elevation-0" text>Esqueceu?</v-btn-->
                                <v-btn
                                    @click="login()"
                                    class="elevation-0"
                                    text
                                    color="primary"
                                >Entrar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapActions } from "vuex";
import Vue from "vue";
import LoginService from "../app/rest/auth";
import VeeValidate from "vee-validate";

var loginService = null;
Vue.use(VeeValidate);

export default {
    $_veeValidate: {
        validator: "new"
    },
    data: () => ({
        show_message: false,

        credential: {
            email: "",
            password: ""
        },
        message: { type: "error", message: null },
        dictionary: {
            attributes: {
                email: "E-mail Address"
                // custom attributes
            },
            custom: {
                email: {
                    required: "E-mail é um campo obrigatório.",
                    email: "Esse não parece um e-mail válido."
                },
                password: {
                    required: "Senha é um campo obrigatório.",
                    min: "Sua senha tem no minimo 8 caracteres."
                }
            }
        }
    }),
    created: function() {
        loginService = LoginService.build();
    },
    updated: function() {
        this.email = "";
        this.password = "";
    },
    mounted() {},
    methods: {
        ...mapActions(["user_authenticate_data"]),
        login() {
            this.show_message = false;
            this.$validator.validateAll().then(is_valid => {
                if (!is_valid) {
                    return;
                }
                this.$store.dispatch("loading");
                loginService
                    .login(this.credential)
                    .then(e => {
                        if (
                            e.token &&
                            e.token.access_token.split(".").length === 3
                        ) {
                            this.user_authenticate_data(e);
                            this.$store.dispatch("loading", false);
                            this.$router.push({ name: "dashboard" });
                        } else {
                            this.show_message = true;
                        }
                    })
                    .catch(e => {
                        //colocar um dialog aqui
                        this.show_message = true;
                    })
                    .finally(w => {
                        this.$store.dispatch("loading", false);
                    });
            });
        }
    }
};
</script>
